import React, { useState } from 'react';
import Calendar from 'react-calendar';

import FormSelect from '../form/select';
import DownloadButton from '../form/downloadButton';

const WalletFinances = ({ isMenuOpen }) => {
  const [date, setDate] = useState(new Date());

  const handleChange = date => {
    setDate(date);
  };

  return (
    <div
      className={`bg-cf-005 py-20 lg:pl-48 lg:pr-20 ${
        isMenuOpen ? 'pl-14 pr-2 md:pl-48 md:pr-8' : 'px-4 md:px-8'
      }`}
    >
      <div className="container mx-auto">
        <div className="flex flex-wrap mb-10">
          <p className="font-hairline text-2xl">Your farm’s financial outlook</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-3">
            <div className="bg-white rounded-lg shadow p-6">
              <div className="text-center font-bold uppercase text-green-600">
                <h5>Farm Finances</h5>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="w-full bg-white rounded-lg shadow-cfw p-3 md:p-6 overflow-hidden">
              <div className="flex flex-wrap justify-between">
                <div className="mb-8 md:mb-0">
                  <h6 className="text-cf-300">Amount Invested</h6>
                  <FormSelect className="mt-4">
                    <option>crop</option>
                  </FormSelect>
                  <h4 className="mt-4">GH 10K</h4>

                  <div className="mt-4 md:mt-56">
                    <p>Estimated profits</p>
                    <h4 className="mt-3">GH 20K</h4>
                  </div>
                </div>

                <div>
                  <h6 className="text-cf-300">Estimated Profits</h6>
                  <div className="w-full md:w-64 md:h-64 text-sm mt-4 overflow-hidden">
                    <Calendar onChange={handleChange} value={date} />
                  </div>

                  <div className="mt-4 md:mt-20">
                    <DownloadButton className="text-cf-300 bg-white" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletFinances;
